import { render, staticRenderFns } from "./onlinePlatform.vue?vue&type=template&id=5ca5ee98"
import script from "./onlinePlatform.vue?vue&type=script&lang=js"
export * from "./onlinePlatform.vue?vue&type=script&lang=js"
import style0 from "./onlinePlatform.vue?vue&type=style&index=0&id=5ca5ee98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports